
import StationCardList from '@/components/modules/StationCardList.vue';
import loader from '@/components/loader'

export default {
    scrollToTop: true,
    data() {
        return {
            cityName: null,
            stations: null,
            loading: true
        };
    },
    head() {
        return {
            title: `MOT in ${this.cityName} | MOT ${this.cityName} | MOT centres in ${this.cityName}`,
            meta: [
                {
                    hid: "og:title",
                    property: "og:title",
                    content: `MOT in ${this.cityName} | MOT ${this.cityName} | MOT centres in ${this.cityName}`
                },
                {
                    hid: "twitter:title",
                    property: "twitter:title",
                    content: `MOT in ${this.cityName} | MOT ${this.cityName} | MOT centres in ${this.cityName}`
                },
            ],
        };
    },
    async validate({ params, store }) {
        // await operations
        if (params.city != (null || "")) {
            this.cityName = params.city;
            return true; // if the params are valid
        }
        else {
            return false; // will stop Nuxt.js to render the route and display the error page
        }
    },
    created() {
        this.cityName = this.$route.params.city;
    },
    async fetch() {
        // Get station data
        this.stations = await fetch(this.$config.fetchUrl + "/api/stations/getStationsByCity/" + this.cityName).then(res => res.json()).catch(error => {
            console.error("There was an error!", error);
            this.$router.push({
                name: "mot-center-cities"
            });
        });
        this.loading = false;
    },
    mounted() {
        window.scrollTo(0, 0);
        // create an object of all query params
        const urlSearchParams = new URLSearchParams(window.location.search);
        const params = Object.fromEntries(urlSearchParams.entries());
        //check if the object is not empty and has cm source
        if (params && Object.keys(params).length > 0) {
            if (params.cm_source && params.cm_source != undefined && params.cm_source != null && params.cm_source != 'undefined' && params.cm_source != 'null' && params.cm_source.trim() != '') {
                localStorage.setItem("cmsource", params.cm_source);
            }
            //if cm source is absent, assign the first query param value to cm source
            else {
                localStorage.setItem("cmsource", 'static');
            }
        }
    },

    components: { StationCardList, loader }
};

